/**
 * Signal reactif de l'etat d'authentification.
 * Import depuis n'importe quel composant pour savoir si l'user est connecte.
 */

import type { AuthUser } from '@services/auth';
import { pocketbaseAuth } from '@services/pocketbase-auth';
import { signal } from './signal';

export type AuthState =
  | { status: 'loading' }
  | { status: 'unauthenticated' }
  | { status: 'authenticated'; user: AuthUser };

export const authState = signal<AuthState>({ status: 'loading' });

let unsubscribe: (() => void) | null = null;

export function initAuth(): void {
  unsubscribe = pocketbaseAuth.onAuthChange((user) => {
    if (user) {
      authState.set({ status: 'authenticated', user });
    } else {
      authState.set({ status: 'unauthenticated' });
    }
  });

  pocketbaseAuth.getUser().then((user) => {
    if (user) {
      authState.set({ status: 'authenticated', user });
    } else {
      authState.set({ status: 'unauthenticated' });
    }
  }).catch(() => {
    authState.set({ status: 'unauthenticated' });
  });
}

export function destroyAuth(): void {
  unsubscribe?.();
}

export function getAuthUser(): AuthUser | null {
  const s = authState.get();
  return s.status === 'authenticated' ? s.user : null;
}

export function isAuthenticated(): boolean {
  return authState.get().status === 'authenticated';
}

export function isMJ(campagneId: string): boolean {
  void campagneId;
  return false;
}
